import { BookOpen } from "lucide-react";
import DocsNavGroup from "./DocsNavGroup";
import sidebarStyles from "../../styles/docs/docsSidebar.module.scss";

const DocsSidebarNav = ({ docNav, activeId, onNavigate, variant = "desktop" }) => (
  <>
    <div className={sidebarStyles.sidebarHeader}>
      <div className={sidebarStyles.headerRow}>
        <BookOpen size={16} className={sidebarStyles.headerIcon} />
        <span className={sidebarStyles.headerTitle}>Documentation</span>
      </div>
      {variant === "desktop" && (
        <p className={sidebarStyles.headerSubtitle}>QA Path — complete guide</p>
      )}
    </div>
    <nav className={sidebarStyles.nav}>
      {docNav.map((group) => (
        <DocsNavGroup
          key={group.id}
          group={group}
          activeId={activeId}
          onNavigate={onNavigate}
          defaultOpen={group.items.some((i) => i.id === activeId)}
        />
      ))}
    </nav>
  </>
);

export default DocsSidebarNav;
